const FeedbackCategory = {
  Like: 'Like',
  Dislike: 'Dislike',
};

export default FeedbackCategory;
